if (!customElements.get('complete-the-set')) {
  customElements.define(
    'complete-the-set',
    class CompleteTheSet extends HTMLElement {
      connectedCallback() {
        this.strings = (window.FoxTheme && window.FoxTheme.variantStrings) || {};
        this.variants = this.parseJSON(this.querySelector('[data-complete-the-set-variants]'));
        this.variantSelects = this.querySelector('variant-selects');
        this.variantIdInput = this.querySelector('[data-variant-id-input]');
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.submitButtonText = this.querySelector('[data-add-to-cart-text]');
        this.priceElement = this.querySelector('[data-price] .f-price');
        this.sizeField = this.querySelector('[data-option-role="size"]');
        this.sizeConfirmed = !this.sizeField;

        this.addToCartLabel = this.submitButton?.dataset.addToCartLabel || this.strings.addToCart || 'Add to Cart';
        this.soldOutLabel = this.submitButton?.dataset.soldOutLabel || this.strings.soldOut || 'Sold Out';
        this.chooseSizeLabel = this.submitButton?.dataset.chooseSizeLabel || 'Choose a Size';

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.addEventListener('change', this.onOptionChange.bind(this), { signal });
        document.addEventListener('product-ajax:added', this.onProductAdded.bind(this), { signal });

        this.applyVariantState(this.getSelectedVariant());
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      parseJSON(node) {
        if (!node) return [];
        try {
          return JSON.parse(node.textContent) || [];
        } catch (error) {
          console.error('complete-the-set: failed to parse variants JSON', error);
          return [];
        }
      }

      onOptionChange(event) {
        if (this.sizeField && event.target.closest('[data-option-role="size"]')) {
          this.sizeConfirmed = true;
        }
        this.applyVariantState(this.getSelectedVariant());
      }

      getSelectedVariant() {
        if (!this.variantSelects) return null;

        const controls = Array.from(this.variantSelects.querySelectorAll('select, fieldset'));
        const selections = controls.map((control) => {
          if (control.tagName === 'SELECT') return control.value;
          const checked = control.querySelector('input:checked');
          return checked ? checked.value : null;
        });

        return this.variants.find((variant) =>
          selections.every((value, index) => value === null || variant.options[index] === value)
        );
      }

      applyVariantState(variant) {
        if (this.variantIdInput) this.variantIdInput.value = variant ? variant.id : '';
        this.updatePrice(variant);

        if (this.sizeField && !this.sizeConfirmed) {
          this.setButtonState(false, this.chooseSizeLabel);
          return;
        }

        if (!variant || !variant.available) {
          this.setButtonState(false, this.soldOutLabel);
          return;
        }

        this.setButtonState(true, this.addToCartLabel);
      }

      setButtonState(ready, label) {
        if (this.submitButtonText) this.submitButtonText.textContent = label;
        if (!this.submitButton) return;

        if (ready) {
          this.submitButton.removeAttribute('aria-disabled');
        } else {
          this.submitButton.setAttribute('aria-disabled', 'true');
        }
      }

      updatePrice(variant) {
        if (!this.priceElement || !variant || !window.FoxTheme?.Currency) return;

        const price = variant.price;
        const compareAtPrice = variant.compare_at_price || 0;
        const moneyFormat = FoxTheme.settings.moneyFormat;

        this.priceElement.classList.remove('f-price--sold-out', 'f-price--on-sale');
        if (!variant.available) {
          this.priceElement.classList.add('f-price--sold-out');
        } else if (compareAtPrice > price) {
          this.priceElement.classList.add('f-price--on-sale');
        }

        const regularItem = this.priceElement.querySelector('.f-price__regular .f-price-item--regular');
        if (regularItem) {
          regularItem.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);
        }

        const saleCompareItem = this.priceElement.querySelector('.f-price__sale .f-price-item--regular');
        if (saleCompareItem) {
          saleCompareItem.innerHTML =
            compareAtPrice > price ? `<s>${FoxTheme.Currency.formatMoney(compareAtPrice, moneyFormat)}</s>` : '';
        }

        const saleItem = this.priceElement.querySelector('.f-price__sale .f-price-item--sale');
        if (saleItem) {
          saleItem.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);
        }
      }

      onProductAdded() {
        const modal = this.closest('basic-modal');
        if (modal?.open) modal.hide();
      }
    }
  );
}
